import { format as formatNewDate } from 'date-fns';
import moment from 'moment-timezone';

const format = (date, dateFormat) => { 
    const user = JSON.parse(sessionStorage.getItem('@Omni:user'));

    if(user) {
        return moment.tz(date, user.timeZone).format('HH:mm DD/MM/YYYY')
    } else {
        return formatNewDate(new Date(date), dateFormat)
    }
}

export default format;
